import { logUsage } from 'owa-analytics';
import { SxSCustomData } from 'owa-sxs';
import getExtraCustomDataForDatapoint from 'owa-sxs-store/lib/utils/getExtraCustomDataForDatapoint';

export default function logSxSCommandBarDatapoint(
    datapointName: string,
    sxsId: string,
    scenarioSpecificData?: SxSCustomData
) {
    const commonData = getExtraCustomDataForDatapoint(sxsId);
    logUsage(
        datapointName,
        { ...commonData.customData, ...scenarioSpecificData?.customData },
        {
            cosmosOnlyData: JSON.stringify({
                ...commonData.cosmosOnlyData,
                ...scenarioSpecificData?.cosmosOnlyData,
            }),
        }
    );
}
